<!--<div class="row">
  <div class="col-lg-1"></div>
  <div class="col-lg-10 paddingZero" [formGroup]="requestQuote">
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="jobNameLBL">{{requestQuoteTxt.jobNameLbl?requestQuoteTxt.jobNameLbl:requestQuotes.jobNameLbl}}<span class="requiredField">*</span> </label>
        <input type="text" kendoTextBox id="jobNameId" formControlName="jobName" #jobNameLBL
               class="kendoInput" [ngClass]="{'borderRed':requestQuoteControls.isInvalidJobName && requestQuoteControls.isSubmitted}"
               (blur)="validateRequestQuoteForm()" />
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="jobCityLBL">{{requestQuoteTxt.jobCityLbl?requestQuoteTxt.jobCityLbl:requestQuotes.jobCityLbl}}<span class="requiredField">*</span> </label>
        <input type="text" kendoTextBox formControlName="jobCity" #jobCityLBL
               class="kendoInput" [ngClass]="{'borderRed':requestQuoteControls.isInvalidCity && requestQuoteControls.isSubmitted}"
               (blur)="validateRequestQuoteForm()" />
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="jobStateLBL">{{requestQuoteTxt.jobStateLbl?requestQuoteTxt.jobStateLbl:requestQuotes.jobStateLbl}}<span class="requiredField">*</span> </label>
        <kendo-dropdownlist class="kendoInput" #jobStateLBL
                            formControlName="jobState"
                            [data]="getjobState"
                            textField="stateDescription"
                            valueField="stateDescription" [ngClass]="{'borderRed':requestQuoteControls.isInvalidState && requestQuoteControls.isSubmitted}"
                            (blur)="validateRequestQuoteForm()">
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row col-lg-12 paddingZero ">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="marketSegmentLBL">{{requestQuoteTxt.marketSegmentLbl?requestQuoteTxt.marketSegmentLbl:requestQuotes.marketSegmentLbl}}<span class="requiredField">*</span></label>
        <kendo-dropdownlist class="kendoInput" #marketSegmentLBL
                            formControlName="marketSegment"
                            [data]="getMarketSegment"
                            textField="name"
                            valueField="value" [ngClass]="{'borderRed':requestQuoteControls.isInvalidMarketSegment && requestQuoteControls.isSubmitted}"
                            (blur)="validateRequestQuoteForm()">
        </kendo-dropdownlist>
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="quoteTypeLbl">{{requestQuoteTxt.quoteTypeLbl?requestQuoteTxt.quoteTypeLbl:requestQuotes.quoteTypeLbl}}<span class="requiredField">*</span></label>
        <kendo-dropdownlist class="kendoInput" #quoteTypeLbl
                            formControlName="quoteType"
                            [data]="getQuoteType"
                            textField="name"
                            valueField="value" [ngClass]="{'borderRed':requestQuoteControls.isInvalidQuoteType && requestQuoteControls.isSubmitted}"
                            (blur)="validateRequestQuoteForm()">
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="requestDateLBL">{{requestQuoteTxt.quoteRequestDate?requestQuoteTxt.quoteRequestDate:requestQuotes.quoteRequestDate}}<span class="requiredField">*</span></label>
        <kendo-datepicker class="kendoInput" formControlName="quoteRequestDate"
                          placeholder="MM/DD/YYYY"
                          #requestDateLBL format="MM/dd/yyyy"
                          [min]="minDate"
                          (valueChange)="onReqDateChange($event)"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" [ngClass]="{'borderRed':requestQuoteControls.isInvalidQuoteRequestDate && requestQuoteControls.isSubmitted}"
                          (blur)="validateRequestQuoteForm()">
        </kendo-datepicker>
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="bidDateLBL">{{requestQuoteTxt.bidDateLbl?requestQuoteTxt.bidDateLbl:requestQuotes.bidDateLbl}}<span class="requiredField">*</span></label>
        <kendo-datepicker class="kendoInput" formControlName="bidDate"
                          placeholder="MM/DD/YYYY"
                          #bidDateLBL format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                          [min]="bidMinDate" [ngClass]="{'borderRed':requestQuoteControls.isInvalidBidDate && requestQuoteControls.isSubmitted}"
                          (blur)="validateRequestQuoteForm()">
        </kendo-datepicker>
      </div>
    </div>
    <div class="checkboxCls paddingZero">
      <span>{{requestQuoteTxt.indicateTypeLbl?requestQuoteTxt.indicateTypeLbl:requestQuotes.indicateTypeLbl}}</span>
      <br />
      <kendo-switch formControlName="leed" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="checkBox-label" [for]="leed">{{requestQuoteTxt.leedLbl?requestQuoteTxt.leedLbl:requestQuotes.leedLbl}} </label>
      <br />
      <kendo-switch formControlName="blast" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="checkBox-label" [for]="blast">{{requestQuoteTxt.blastLbl?requestQuoteTxt.blastLbl:requestQuotes.blastLbl}} </label>
      <br />
      <kendo-switch formControlName="customerSupplied" [onLabel]="'Yes'" [offLabel]="'No'">
      </kendo-switch>
      <label class="checkBox-label" [for]="customerSupplied">{{requestQuoteTxt.customerSuppliedHardwareLbl?requestQuoteTxt.customerSuppliedHardwareLbl:requestQuotes.customerSuppliedHardwareLbl}} </label>
      <br />
      <kendo-switch formControlName="purchaseHardware" [onLabel]="'Yes'" [offLabel]="'No'" class="">
      </kendo-switch>
      <label class="checkBox-label" [for]="purchaseHardware">{{requestQuoteTxt.purchaseHardware?requestQuoteTxt.purchaseHardware:requestQuotes.purchaseHardware}} </label>

    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-12 paddingZero">
        <label class="lbl" [for]="fileAttachment">{{requestQuoteTxt.attachmentLbl?requestQuoteTxt.attachmentLbl:requestQuotes.attachmentLbl}} </label>
        <div style="padding-top: 35px">
          <app-upload [multiple]="true" (fileSelect)="fileSelected($event)" [uploadFolderPath]="'TempDocs\\Quote'"
                      (uploadSuccess)="uploadSuccess($event)" (uploadComplete)="uploadComplete()"  [fileRestrictions] ="fileRestrictions" [myFiles]="myFiles"></app-upload>
          </div>
        </div>
      </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-12 paddingZero" (blur)="validateRequestQuoteForm()">
        <label class="lbl" [for]="projectDetails">
          {{requestQuoteTxt.projectDetails?requestQuoteTxt.projectDetails:requestQuotes.projectDetails}}<span class="requiredField">*</span>
          <span title="{{requestQuoteTxt.invalidProjectDetailsLbl?requestQuoteTxt.invalidProjectDetailsLbl:requestQuotes.invalidProjectDetailsLbl}}" *ngIf="this.requestQuoteControls.isInvalidProjectDetails" kendoTooltip
                class="k-icon k-i-information k-i-info spanInfo"></span>
        </label>
        <kendo-editor #projectDetails class="kendoInput" formControlName="projectDetails"
                      [ngClass]="{'borderRed':requestQuoteControls.isInvalidProjectDetails && requestQuoteControls.isSubmitted}"
                      (blur)="validateRequestQuoteForm()"></kendo-editor>
      </div>
    </div>
    <div class="col-lg-12 button-middle">
      <button class="cancel-button" kendoButton (click)="cancel()" [disabled]="saveInProcess">{{requestQuoteTxt.cancelButtonLbl?requestQuoteTxt.cancelButtonLbl:requestQuotes.cancelButtonLbl}}</button>
      <button kendoButton class="m-3 clearKendoButton btn btn-success" [icon]="'file-txt'" (click)="requestQuoteSubmit()" [disabled]="saveInProcess">{{requestQuoteTxt.requestQuoteButtonLbl?requestQuoteTxt.requestQuoteButtonLbl:requestQuotes.requestQuoteButtonLbl}} <kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader></button>

    </div>
  </div>
</div>-->
<!--Need to add cancel button confirmation popup-->
<!--<section>
  <kendo-dialog title="{{requestQuoteTxt.confirmTitleLbl?requestQuoteTxt.confirmTitleLbl:requestQuotes.confirmTitleLbl}}" *ngIf="showCancelConfirmation" (close)="confirmCancel(false)">
    <p style="margin: 30px; text-align: center;">
      {{requestQuoteTxt.cancelConfirmLbl?requestQuoteTxt.cancelConfirmLbl:requestQuotes.cancelConfirmLbl}}
    </p>
    <kendo-dialog-actions>
      <button class='k-button' (click)="confirmCancel(false)">
        {{requestQuoteTxt.noLbl?requestQuoteTxt.noLbl:requestQuotes.noLbl}}
      </button>
      <button class='k-button k-primary' (click)="confirmCancel(true)" primary="true">
        {{requestQuoteTxt.yesLbl?requestQuoteTxt.yesLbl:requestQuotes.yesLbl}}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <div class="k-overlay" *ngIf="confirmWindowOpened"></div>
  <kendo-dialog [minWidth]="200" [minHeight]="125" title="{{requestQuoteTxt.quoteSubmittedLbl?requestQuoteTxt.quoteSubmittedLbl:requestQuotes.quoteSubmittedLbl}}" *ngIf="confirmWindowOpened" (close)="confirmWindowClose()">

    <div>
      {{requestQuoteTxt.requestSubmittedToKawneerLbl?requestQuoteTxt.requestSubmittedToKawneerLbl:requestQuotes.requestSubmittedToKawneerLbl}}
      <br>
      {{requestQuoteTxt.quoteGridLbl?requestQuoteTxt.quoteGridLbl:requestQuotes.quoteGridLbl}}  {{requestQuoteTxt.thanksLbl?requestQuoteTxt.thanksLbl:requestQuotes.thanksLbl}}
      <br><br>
      <div>
        <strong>{{requestQuoteTxt.submittedJobLbl?requestQuoteTxt.submittedJobLbl:requestQuotes.submittedJobLbl}}</strong>: <span>{{jobName}}</span>
        <div *ngFor="let fileName of uploadedfileNames">{{fileName}}</div>
      </div>
      <br>
      <a [routerLink]="['/manage-quote/in-house-quote']">{{requestQuoteTxt.returnToInHouseQuoteLbl?requestQuoteTxt.returnToInHouseQuoteLbl:requestQuotes.returnToInHouseQuoteLbl}}</a>
      &nbsp;|&nbsp;
      <a href="javascript:void" (click)="newQuoteRequest()">{{requestQuoteTxt.addNewQuoteRequestLbl?requestQuoteTxt.addNewQuoteRequestLbl:requestQuotes.addNewQuoteRequestLbl}}</a>

    </div>
  </kendo-dialog>

  <kendo-dialog title="{{requestQuoteTxt.confirmTitleLbl?requestQuoteTxt.confirmTitleLbl:requestQuotes.confirmTitleLbl}}"
                *ngIf="openedNoFileConfirmationBox"
                (close)="closeNoFileConfirmationBox(false)"
                [minWidth]="250"
                [width]="450">
    <p style="margin: 30px; text-align: center;">
      {{requestQuoteTxt.noFilesUploadedLbl?requestQuoteTxt.noFilesUploadedLbl:requestQuotes.noFilesUploadedLbl}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="closeNoFileConfirmationBox(false)"> {{requestQuoteTxt.noLbl?requestQuoteTxt.noLbl:requestQuotes.noLbl}}</button>
      <button kendoButton (click)="closeNoFileConfirmationBox(true)" primary="true">{{requestQuoteTxt.yesLbl?requestQuoteTxt.yesLbl:requestQuotes.yesLbl}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</section>-->



<div class="row">
  <div class="col-md-12">
    <div style="min-height:400px;">
      <b>This screen is currently undergoing maintenance and is not available.  Please direct your quote request to your Kawneer representative.</b>
    </div>
  </div>
</div>
